
import { Options, Vue } from "vue-class-component";
import Close from "@/app/ui/components/icons/modules/close.vue";
import { resolveCountry } from "@/app/infrastructures/misc/common-library/FormatByCountry";
@Options({
  emits: ["update:length", "update:width", "update:height", "change", "onClickViewDisabledInput"],
  components: {
    Close
  },
  props: {
    length: {
      default: 10,
      type: Number,
      required: true
    },
    width: {
      default: 20,
      type: Number,
      required: true
    },
    height: {
      default: 30,
      type: Number,
      required: true
    },
    disabled: {
      default: false,
      type: Boolean
    },
    error: {
      default: false,
      type: Boolean
    },
    errorCaption: {
      default: "",
      type: String
    },
    withIcon: {
      default: true,
      type: Boolean
    },
  showViewDisabledInput: {
    default: false,
    type: Boolean
  },
    format: {
      default: null,
      type: Function
    },
    isNumber: {
      default: true,
      type: Boolean
    },
    customStyle: {
      default: "",
      type: String
    },
    maxLength: {
      default: "",
      type: String
    },
    sizeProportional: {
      default: "py-2.5",
      type: String
    },
  },
  watch: {
    length() {
      if (this.maxLength && this.length?.length > Number(this.maxLength)) {
        this.$emit(
          "update:modelValue",
          this.length.slice(0, Number(this.maxLength))
        );
      }
    },
    width() {
      if (this.maxLength && this.width?.length > Number(this.maxLength)) {
        this.$emit(
          "update:modelValue",
          this.width.slice(0, Number(this.maxLength))
        );
      }
    },
    height() {
      if (this.maxLength && this.height?.length > Number(this.maxLength)) {
        this.$emit(
          "update:modelValue",
          this.height.slice(0, Number(this.maxLength))
        );
      }
    }
  }
})
export default class InputDimension extends Vue {
  props: any = this.$props;
  setInput(e: any) {
    if (this.props.format) {
      e.target.value = this.props.format(e.target.value);
    }

    const country = resolveCountry();
    if (country === "MY") {
      e.target.value = e.target.value
        .replace(/[^0-9.]/g, "")
        .replace(/\.+/g, ".")
        .replace(/(\.\d+)\./g, "$1")
        .replace(/^\./, "");
    } else {
      e.target.value = e.target.value
        .replace(/[^0-9.,]/g, "")
        .replace(/[.]+|[,]+/g, ",")
        .replace(/,(\d+),/g, ",$1")
        .replace(/(,.*?),(.*,)?/, "$1")
        .replace(/^,/, "");
    }

    const value = this.props.isNumber
      ? Number(country === "MY" ? e.target.value : e.target.value.replace(/,/g, "."))
      : e.target.value;
    if (e.target.name === "length") {
      this.$emit("update:length", value);
      this.$emit("change", {
        length: value,
        width: this.props.width,
        height: this.props.height
      });
    } else if (e.target.name === "width") {
      this.$emit("update:width", value);
      this.$emit("change", {
        length: this.props.length,
        width: value,
        height: this.props.height
      });
    } else {
      this.$emit("update:height", value);
      this.$emit("change", {
        length: this.props.length,
        width: this.props.width,
        height: value
      });
    }
  }

  get lengthValue() {
    const str = this.props.length.toString();
    return resolveCountry() === "MY" ? str : str.replace(".", ",");
  }

  get widthValue() {
    const str = this.props.width.toString();
    return resolveCountry() === "MY" ? str : str.replace(".", ",");
  }

  get heightValue() {
    const str = this.props.height.toString();
    return resolveCountry() === "MY" ? str : str.replace(".", ",");
  }

  onClickInput() {
    this.$emit("onClickViewDisabledInput");
  }
}
